module.exports = __webpack_public_path__ + "static/media/moneyandcar.2f6b91f2.png";